import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const UserManagementPage = lazy(() => import('src/pages/users/user-management'));
const UserCreatePage = lazy(() => import('src/pages/users/user-create'));
const UserEditPage = lazy(() => import('src/pages/users/user-edit'));
const UserProfilePage = lazy(() => import('src/pages/users/user-profile'));

// ----------------------------------------------------------------------

export const userRoutes = [
  {
    path: 'users',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { element: <UserManagementPage />, index: true },
      {
        path: '/users/create',
        element: <UserCreatePage />,
      },
      {
        path: '/users/:orgId/:userId/edit',
        element: <UserEditPage />,
      },
      {
        path: '/users/:userId',
        element: <UserProfilePage />,
      },
    ],
  },
];
